<template>
  <CustomTable title="" :rowsData="this.rowsData" :columns="this.providersColumns" :loading="isFetching"
    :custom-body="true" :small="true" :sticky-header="false" :add-btn="true" :on-add-click="this.onAddClick"
    :addBtnTitle="'Добавить поставщика'">
    <template #customBody="props">
      <q-tr>
        <custom-table-cell align="center" verticalAlign="center">
          {{ props.row.material_provider_id }}
        </custom-table-cell>

        <custom-table-cell align="left" verticalAlign="center" style="width: 250px">
          {{ props.row.provider_name }}
        </custom-table-cell>

        <custom-table-cell align="left" verticalAlign="center" style="width: 250px">
          {{ props.row.provider_material_name }}
        </custom-table-cell>

        <custom-table-cell align="center" verticalAlign="center">
          <div style="display: flex; flex-direction: column; gap: 2px;">
            <div>
              {{ props.row.price_whole !== null && props.row.price_whole !== undefined
                ? numberWithCommas(props.row.price_whole)
                : '-' }}
            </div>
            <div v-if="props.row.price_whole_nds !== null && props.row.price_whole_nds !== undefined"
              style="font-size: 11px; color: #6b7280;">
              с НДС: {{ numberWithCommas(props.row.price_whole_nds) }}
            </div>
          </div>
        </custom-table-cell>

        <custom-table-cell align="center" verticalAlign="center" style="width: 450px">
          <div v-if="props.row.date_begin && props.row.date_end" class="provider-info">
            <CustomPopup width="1000" :noPadding="true">
              <template #head>
                <Clickable>
                  {{ props.row.date_begin }} - {{ props.row.date_end }}
                </Clickable>
              </template>
              <template #default>
                  <PriceTable :provider="props.row" :filters="this.currentFilters" @refresh-materials-data="refreshMaterialsData" @refresh-providers-data="refreshProvidersData" />
                </template>
            </CustomPopup>
          </div>
          <div v-else>
            <CustomButton style="height: 32px; width: auto;" @click="onAddPriceClick(props.row)">
              <span>Добавить цену</span>
            </CustomButton>
          </div>
        </custom-table-cell>

        <custom-table-cell align="center" verticalAlign="center">
          <CustomCheckbox :value="props.row.is_main === 1 ? true : false" :disable />
        </custom-table-cell>

        <custom-table-cell align="center" verticalAlign="center">
          <CustomCheckbox :value="props.row.is_avail === 1 ? true : false" :disable />
        </custom-table-cell>

        <custom-table-cell align="center" verticalAlign="center">
          <SvgIcon name="edit" color="#1BB81B" style="width: 16px; height: 16px; cursor: pointer"
            @click="onEditClick(props.row)" />
        </custom-table-cell>

        <custom-table-cell align="center" vertical-align="center">
          <CustomIcon icon="trash" approveMode :approve="() => this.delete(props.row?.material_provider_id)" />
        </custom-table-cell>
      </q-tr>
    </template>
  </CustomTable>
</template>

<script>
import { useCustomSnackbar } from '@/_helpers/hooks/useCustomSnackbar'
import Clickable from '@/components/common/Clickable'
import CustomIcon from '@/components/common/CustomIcon'
import CustomPopup from '@/components/common/CustomPopup'
import CustomTable from '@/components/common/CustomTable'
import CustomTableCell from '@/components/common/CustomTable/custom-table-cell'
import SvgIcon from '@/components/common/SvgIcon'
import CustomCheckbox from '@/components/form/CustomCheckbox'
import { MODAL_NAMES } from '@/constants'
import { useAppStore } from '@/services/store/app'
import PriceTable from './PriceTable.vue'
import { getMaterialProvidersList, providersColumns, updProvider, updProviderPrice, deleteMaterialProvider } from './services'
import CustomButton from '@/components/common/CustomButton'
import {numberWithCommas} from "@/services"

export default {
  name: 'LinksTable',
  components: {
    CustomIcon,
    CustomTableCell,
    CustomTable,
    CustomPopup,
    SvgIcon,
    CustomCheckbox,
    Clickable,
    PriceTable,
    CustomButton
  },
  props: ['material_id', 'filters', 'onDataChange'],
  data() {
    return {
      providersColumns,
      rowsData: [],
      isFetching: false,
      params: {
        material_id: this.material_id,
      },
    }
  },
  methods: {
    numberWithCommas,
    onAddClick() {
      this.showModal(MODAL_NAMES.AddProviderEntry, {
        title: 'Добавить поставщика',
        onSubmit: this.handleProviderEntry,
        body: {
          material_id: this.material_id,
        },
      })
    },
    onEditClick(row) {
      this.showModal(MODAL_NAMES.AddProviderEntry, {
        title: 'Редактировать поставщика',
        onSubmit: body => this.handleProviderEdit(body),
        body: row,
      })
    },
    onAddPriceClick(row) {
      const params = {
        material_provider_id: row.material_provider_id,
        material_id: this.material_id
      }
      this.showModal(MODAL_NAMES.AddMaterialProviderPrice, {
        title: 'Добавить цену',
        onSubmit: body => this.handlePriceAdd(body, params),
        body: row,
      })
    },
    async handleProviderEntry(body) {
      this.isFetching = true;
      const res = await updProvider(body, this.params);
      if (!res) {
        return;
      }
      this.rowsData = res || [];
      this.refreshMaterialsData();
      this.isFetching = false;
      this.showSucceedSnackbar();
      this.closeModal();
    },
    async handleProviderEdit(body) {
      this.isFetching = true;
      const res = await updProvider(body, this.params);
      if (!res) {
        return;
      }
      this.rowsData = res || [];
      this.isFetching = false;
      this.showSucceedSnackbar();
      this.closeModal();
    },
    async handlePriceAdd(body, params) {
      this.isFetching = true;
      const res = await updProviderPrice(body, params);
      if (!res) {
        return;
      }
      this.rowsData = res || [];
      this.isFetching = false;
      this.refreshMaterialsData();
      this.showSucceedSnackbar();
      this.closeModal();
    },
    async getData() {
      this.isFetching = true
      const res = await getMaterialProvidersList({
        material_id: this.material_id,
      })
      this.isFetching = false
      if (!res) return
      this.rowsData = res || []
    },
    refreshMaterialsData() {
      this.$emit('refresh-materials-data');
    },
    async delete(id) {
      this.isFetching = true
      const res = await deleteMaterialProvider(id, this.params)
      this.isFetching = false
      if (!res) return
      this.rowsData = res || []
      this.refreshMaterialsData();
      this.showSucceedSnackbar()
    },
    refreshProvidersData() {
      this.getData();
    },
  },
  mounted() {
    this.getData()
  },
  setup() {
    const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar()
    const { showModal, closeModal } = useAppStore()
    return { showSucceedSnackbar, showErrorSnackbar, showModal, closeModal }
  },
}
</script>

<style scoped lang="scss">
.link {
  color: #00368b;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
}
</style>
